// src/index.js
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import ScrollToTop from './components/ui/back_to_top';
import AppRoutes from './routes/AppRoutes';
import {TextHoverEffect} from './components/ui/Splash';
import AOS from 'aos';
import 'aos/dist/aos.css';


const App = () => {

  AOS.init({
    duration: 1000, // Duration of animation in milliseconds
    once: true, // Animation only happens once
  });

  const [loading, setLoading] = useState(true);
  const [darkMode] = useState(true); // Add dark mode state

  useEffect(() => {
    // Simulate a loading delay
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000); // Adjust the delay as needed (in milliseconds)

    return () => clearTimeout(timer); // Cleanup the timer
  }, []);

  return (
    <>
      <div className={`bg-black ${darkMode ? 'dark' : ''}`}>
        <Router>
          {loading ? (
            <div className="h-screen flex items-center justify-center">
              <TextHoverEffect text="ALGOARTS" 
                showLogo={true}
                showTextEffect={true}
                logoDuration={4}
                textDuration={2}/>
            </div>
          ) : (
            <AppRoutes />
          )}
        </Router>
        <ScrollToTop />
      </div>
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
